import React, { useEffect, useState, } from 'react'
import { useParams } from 'react-router';

import axios from 'axios';

import useAuth from '../../controllers/users/useAuth';

import {
    checkIfCallPrinterAsync, responseGet, globalSettings, numberSet, separatorsNumbersSet, styles, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, awaitDelay, LoadingSection,
    languageObjGet, isUndNullEmp,
} from '../../helpers/settings';
import HtmlParser from 'react-html-parser';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { apartmentReceiptModelGet } from '../../models/apartments/apartmentReceipt';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { receiptModelGet } from '../../models/receipts/receipt';
import { apartmentReceiptPaymentModelGet } from '../../models/payments/apartmentReceiptPayment';
import { expenseTemplateModelGet } from '../../models/expenses/template';
import { conceptModelGet } from '../../models/expenses/concept';
import { paymentMethodModelGet } from '../../models/paymentMethods/paymentMethod';
import { apartmentReceiptDetailModelGet } from '../../models/apartments/apartmentReceiptDetail';

const currentMethod = 'ReceiptPrint';

const { app, html, images, labels, messages, } = globalSettings;

export default function ReceiptPrint({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    const { id, } = useParams();
    const neutralValue = 0.00;
    const neutralValueStr = separatorsNumbersSet({
        number: neutralValue,
        withDecimals: true,
        consoleLogErrorShow: true,
        subMethod: currentMethod,
    })?.result;
    //#endregion variables

    //#region building
    const [building, setBuilding] = useState(buildingModelGet({}));
    //#endregion building

    //#region apartment
    const [apartment, setApartment] = useState(apartmentModelGet({}));
    const [apartmentReceipt, setApartmentReceipt] = useState(apartmentReceiptModelGet({}));
    //#endregion apartment

    //#region receipt
    const [receipt, setReceipt] = useState(receiptModelGet({}));
    const [showObj, setShowObj] = useState({ loading: true, report: false, });
    const [receiptDetails, setReceiptDetails] = useState([receiptModelGet({})]);
    //#endregion receipt

    //#region payments
    const [payments, setPayments] = useState([]);
    //#endregion payments

    //#region methods
    const dataGetAsync = async ({
        subMethod = '' }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let payments = [];
            let price = neutralValue;
            let receiptDetailRows = [];
            let subTotal = neutralValue;
            let receipt = receiptModelGet({});
            let building = buildingModelGet({});
            let apartment = apartmentModelGet({});
            let expenseConcepts = [conceptModelGet({})];
            let paymentMethods = [paymentMethodModelGet({})];
            let expenseTemplate = expenseTemplateModelGet({});
            let apartmentReceipt = apartmentReceiptModelGet({});
            let apartmentReceiptDetails = [apartmentReceiptDetailModelGet({})];
            let apartmentReceiptPayments = [apartmentReceiptPaymentModelGet({})];
            //#endregion variables

            //#region data get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                id: id,
                languageCode: languageObj?.code,
                languageId: languageObj?.id,
                url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceipts}/print`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setShowObj({ loading: false, report: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: true,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            apartmentReceipt = response?.result?.apartmentReceipt || {};
            setApartmentReceipt(apartmentReceipt);

            apartmentReceiptPayments = response?.result?.apartmentPayments || []

            receipt = response?.result?.receipt || {};
            setReceipt(receipt);

            expenseTemplate = response?.result?.expenseTemplate || {};

            expenseConcepts = response?.result?.expenseConcepts || [];

            apartment = response?.result?.apartment || {};
            setApartment(apartment);

            building = response?.result?.building || {};
            setBuilding(building);

            paymentMethods = response?.result?.paymentMethods || [];

            apartmentReceiptDetails = response?.result?.apartmentReceiptDetails || [];
            //#endregion data get

            //#region add rows in datatables
            //#region receipt details
            expenseTemplate?.details?.forEach((detail) => {
                //#region variables
                const objRow = {
                    price: numberSet({
                        number: detail?.price,
                        type: 'd',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    quantity: numberSet({
                        number: detail?.quantity,
                        type: 'd',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    receiptGenerateds: numberSet({
                        number: receipt?.receiptGenerateds,
                        type: 'd',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                };
                //#region old code
                //price = numberSet(((numberSet(detail.price, 'd').result) / (numberSet(receipt.receiptGenerateds, 'd').result)), 'd').result;
                //subTotal = numberSet((numberSet(detail.quantity, 'd').result) * price, 'd').result;
                //#endregion old code
                price = numberSet({
                    number: objRow?.price / objRow?.receiptGenerateds,
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                subTotal = numberSet({
                    number: objRow?.quantity * price,
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                //#endregion variables

                //#region methods
                receiptDetailRows?.push({
                    id: detail?.id,
                    description: expenseConcepts?.find(({ id }) => id === detail?.id)?.description || '',
                    quantity: separatorsNumbersSet({
                        number: objRow?.quantity,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                    //#region old code
                    //price: separatorsNumbersSet(price, true).result,
                    //subTotal: separatorsNumbersSet(subTotal, true).result,
                    //#endregion old code
                    price: separatorsNumbersSet({
                        number: price,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                    subTotal: separatorsNumbersSet({
                        number: subTotal,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                });
                //#endregion variables
            });

            apartmentReceiptDetails?.forEach((detail) => {
                //#region variables
                const objRow = {
                    price: numberSet({
                        number: detail?.price,
                        type: 'd',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    quantity: numberSet({
                        number: detail?.quantity,
                        type: 'd',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                };
                subTotal = numberSet({
                    number: objRow?.quantity * price,
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                //#endregion variables
                //#region old code
                //subTotal = numberSet(numberSet(detail.quantity, 'd').result * numberSet(detail.price, 'd').result, 'd').result;
                //#endregion old code

                //#region methods
                receiptDetailRows?.push({
                    id: detail?.id,
                    description: expenseConcepts?.find(({ id }) => id === detail?.expenseConceptId)?.description || '',
                    //#region old code
                    // quantity: separatorsNumbersSet(detail.quantity, true).result,
                    // price: separatorsNumbersSet(detail.price, true).result,
                    // subTotal: separatorsNumbersSet(subTotal, true).result,
                    //#endregion old code
                    quantity: separatorsNumbersSet({
                        number: objRow?.quantity,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                    price: separatorsNumbersSet({
                        number: objRow?.price,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                    subTotal: separatorsNumbersSet({
                        number: subTotal,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                });
                //#endregion methods
            });

            //receiptDetailRows = orderBy(receiptDetailRows, 'description', 'asc');
            const keyStr = globalSettings?.collections?.properties?.description;
            //receiptDetailRows = receiptDetailRows?.sort((a, b) => a?.[keyStr]?.toLowerCase()?.trim()?.compareLocale(b?.[keyStr]?.toLowerCase()?.trim()))
            receiptDetailRows = receiptDetailRows?.sort((a, b) => a?.[keyStr]?.toLowerCase()?.trim() > b?.[keyStr]?.toLowerCase()?.trim() ? 1 : -1);
            setReceiptDetails(receiptDetailRows);
            //#endregion receipt details

            //#region payments
            apartmentReceiptPayments?.forEach((detail) => {
                payments.push({
                    id: detail?.id,
                    description: paymentMethods?.find(({ id }) => id === detail?.paymentMethodId)?.description || '',
                    reference: detail?.reference,
                    date: dateTimeFormatGlobalSet({
                        date: detail?.date,
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    amount: separatorsNumbersSet({
                        number: detail?.amount,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                });
            });

            setPayments(payments);
            //#endregion payments
            //#endregion add rows in datatables

            //#region show printer promp
            response = await checkIfCallPrinterAsync({
                checkIfOnlyIsMobile: false,
                subMethod: currentMethod,
            });

            if (!response.isSuccess) {
                setShowObj({ loading: false, report: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: true,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const showPrinterPromp = response?.result || false;

            setShowObj({ loading: false, report: true, });

            if (showPrinterPromp) {
                //await new Promise(r => setTimeout(r, globalSettings?.timers?.oneSecond));
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                window?.addEventListener('load', window?.print());
            }
            //#endregion show printer promp
        } catch (ex) {
            setShowObj({ loading: false, report: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: true,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion methods

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, [id]) //eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            {!showObj?.loading ?
                <div className='container mt-4'>
                    {showObj?.report ?
                        <div className='card card-outline card-secondary elevation-3 shadow-lg'>
                            <div className='card-header'>
                                <h5 className='card-title'>
                                    <img src={images?.appLogo}
                                        alt='appLogo'
                                        className='brand-image img-circle elevation-3'
                                        style={styles.receiptPrintLogo} />
                                    {app?.name}

                                    <div className='text-muted' style={{ fontSize: '13px' }}>
                                        {HtmlParser(html?.space?.formatSevenTeen)}{messages?.theOnlyAndBestProgramInCondominiumManagement?.[languageObj?.id]}
                                    </div>
                                </h5>

                                <div className='card-tools'>
                                    <ul className='list-unstyled float-right'>
                                        <li>
                                            {labels?.date?.[languageObj?.id]}: <b>{
                                                dateTimeFormatGlobalSet({
                                                    date: new Date(),
                                                    type: languageObj?.format?.date?.f1,
                                                    format: 0,
                                                    addTime: false,
                                                    secondsShow: false,
                                                    languageId: languageObj?.id,
                                                    subMethod: currentMethod,
                                                })?.result
                                            }</b>
                                        </li>
                                        <li>
                                            {labels?.time?.[languageObj?.id]}: <b>{
                                                dateTimeFormatGlobalSet({
                                                    date: new Date(),
                                                    type: '',
                                                    format: languageObj?.format?.time?.type,
                                                    addTime: false,
                                                    secondsShow: false,
                                                    languageId: languageObj?.id,
                                                    subMethod: currentMethod,
                                                })?.result
                                            }</b>
                                        </li>
                                    </ul>
                                </div>

                                {/* <div className='row'>
                                <div className='col-12'>
                                    <h4 className='page-header'>
                                        <img src={images?.appLogo} 
                                            alt='appLogo' 
                                            className='brand-image img-circle elevation-3'
                                            style={styles.receiptPrintLogo} /> {app?.name}
                                        <ul className='list-unstyled float-right'>
                                            <li>
                                                <small>{`${labels?.date?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), 'd/m/y', 0)}`}</small>
                                            </li>
                                            <li>
                                                <small>{`${labels?.time?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), '', 12)}`}</small>
                                            </li>
                                        </ul>
                                    </h4>
                                </div>
                            </div> */}
                            </div>
                            <div className='card-body'>

                                <section className='invoice'>

                                    {/* title row */}
                                    {/* <div className='row'>
                                    <div className='col-12'>
                                        <h4 className='page-header'>
                                            <img src={images?.appLogo} 
                                                alt='appLogo' 
                                                className='brand-image img-circle elevation-3'
                                                style={styles.receiptPrintLogo} /> {app?.name}
                                            <ul className='list-unstyled float-right'>
                                                <li>
                                                    <small>{`${labels?.date?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), 'd/m/y', 0)}`}</small>
                                                </li>
                                                <li>
                                                    <small>{`${labels?.time?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), '', 12)}`}</small>
                                                </li>
                                            </ul>
                                        </h4>
                                    </div>
                                </div> */}
                                    {/* 
                                <div className='row'>
                                    <div className='cold-12'>
                                        <hr />
                                    </div>
                                </div> */}

                                    {/* info row */}
                                    <div className='row invoice-info'>
                                        <div className='col-sm-4 invoice-col'>
                                            <address className='mx-2'>
                                                {labels?.building?.[languageObj?.id]}: <b>{building?.description || ''}</b><br />
                                                {labels?.phone?.[languageObj?.id]}: {building?.phoneNumber || ''}<br />
                                                {labels?.address?.[languageObj?.id]}: {building?.address || ''}<br />
                                                {labels?.email?.[languageObj?.id]}: {building?.email || ''}<br />
                                                {/* <i className='far fa-building'></i> <b>{!isUndefined(building.description) ? building.description : ''}</b><br />
                                            <i className='fas fa-mobile-alt'></i> {!isUndefined(building.phoneNumber) ? building.phoneNumber : ''}<br />
                                            <i className={icons?.mapMarker}></i> {!isUndefined(building.address) ? building.address : ''}<br />
                                            <i className={icons?.envelope}></i> {!isUndefined(building.email) ? building.email : ''}<br /> */}
                                            </address>
                                        </div>
                                        {/* /.col */}
                                        <div className='col-sm-4 invoice-col border-left'>
                                            <address>
                                                {labels?.apartment?.[languageObj?.id]}: <b>{apartment?.identifier || ''}</b><br />
                                                {labels?.phone?.[languageObj?.id]}: {apartment?.phoneNumber || ''}<br />
                                                {labels?.floor?.[languageObj?.id]}: {apartment?.floor || ''}<br />
                                                {/* <i className='fas fa-house-user'></i> <b>{!isUndefined(apartment.identifier) ? apartment.identifier : ''}</b><br />
                                            <i className='fas fa-mobile-alt'></i> <b>{!isUndefined(apartment.phoneNumber) ? apartment.phoneNumber : ''}</b><br />
                                            <i className={icons?.layerGroup}></i> {!isUndefined(apartment.floor) ? apartment.floor : ''}<br /> */}
                                            </address>
                                        </div>
                                        {/* /.col */}
                                        <div className='col-sm-4 invoice-col border-left'>
                                            {/* <i className={icons?.fileInvoice}></i> <b>{apartmentReceipt.receiptNumberApartment}</b><br />
                                        <br />
                                        <i className='far fa-file-alt'></i> {apartmentReceipt.receiptNumber}<br />
                                        <i className={icons?.calendarAlt}></i> {`${dateTimeFormatSet(receipt.from.seconds, 'd/m/y', 0)} - ${dateTimeFormatSet(receipt.to.seconds, 'd/m/y', 0)}`}<br /> */}
                                            {labels?.receipt?.[languageObj?.id]}: <b>{apartmentReceipt?.receiptNumberApartment}</b><br />
                                            <br />
                                            {`${labels?.receipt?.[languageObj?.id]} (master)`}: {apartmentReceipt?.receiptNumber}<br />
                                            {labels?.from?.[languageObj?.id]}: <b>{
                                                dateTimeFormatGlobalSet({
                                                    date: receipt?.from,
                                                    type: languageObj?.format?.date?.f1,
                                                    format: 0,
                                                    addTime: false,
                                                    secondsShow: false,
                                                    languageId: languageObj?.id,
                                                    subMethod: currentMethod,
                                                })?.result
                                            }</b>
                                            <br />
                                            {labels?.to?.[languageObj?.id]}: <b>{
                                                dateTimeFormatGlobalSet({
                                                    date: receipt?.to,
                                                    type: languageObj?.format?.date?.f1,
                                                    format: 0,
                                                    addTime: false,
                                                    secondsShow: false,
                                                    languageId: languageObj?.id,
                                                    subMethod: currentMethod,
                                                })?.result
                                            }</b>
                                            <br />
                                        </div>
                                        {/* /.col */}
                                    </div>

                                    {/* /.row */}
                                    {/* Table row */}
                                    <div className='row'>
                                        <div className='col-12 table-responsive'>
                                            <table className={html?.dataTables?.formats?.smStripedBordered}>
                                                <thead>
                                                    <tr>
                                                        <th>{labels?.concept?.[languageObj?.id]}</th>
                                                        <th className='text-right'>{labels?.quantity?.[languageObj?.id]}</th>
                                                        <th className='text-right'>{labels?.amount?.[languageObj?.id]}</th>
                                                        <th className='text-right'>{labels?.subTotal?.[languageObj?.id]}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {receiptDetails?.map((detail) => (
                                                        <tr key={detail?.id}>
                                                            <td>{detail?.description}</td>
                                                            <td className='text-right'>{detail?.quantity}</td>
                                                            <td className='text-right'>{detail?.price}</td>
                                                            <td className='text-right'>{detail?.subTotal}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        {/* /.col */}
                                    </div>

                                    <br />

                                    {/*payments*/}
                                    <div className='row'>
                                        <div className='col-8'>
                                            {labels?.payments?.[languageObj?.id]}
                                        </div>
                                        <div className='col-8'>
                                            <hr />
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-12 table-responsive'>
                                            <table className={html?.dataTables?.formats?.smStripedBordered}>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            {labels?.type?.[languageObj?.id]}
                                                        </th>
                                                        <th>
                                                            {labels?.reference?.[languageObj?.id]}
                                                        </th>
                                                        <th>
                                                            {labels?.date?.[languageObj?.id]}
                                                        </th>
                                                        <th className='text-right'>
                                                            {labels?.amount?.[languageObj?.id]}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {payments?.map((detail) => (
                                                        <tr key={detail?.id}>
                                                            <td>{detail?.description}</td>
                                                            <td>{detail?.reference}</td>
                                                            <td>{detail?.date}</td>
                                                            <td className='text-right'>{detail?.amount}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    {/* /.row */}
                                    <div className='row'>
                                        {/* accepted payments column */}
                                        <div className='col-6'>
                                            <p className='lead'>{labels?.paymentMethods?.[languageObj?.id]}:</p>
                                            <img className='mx-1 elevation-3' src={images?.visaLogo} alt='visa' />
                                            <img className='elevation-3' src={images?.masterCardLogo} alt='mastercard' />
                                            <img className='mx-1 elevation-3' src={images?.americanExpressLogo} alt='americanExpress' />
                                            <img className='elevation-3' src={images?.payPalLogo} alt='paypal' />
                                            <img className='mx-1 elevation-3' src={images?.zelleLogo} alt='zelle' />
                                            <img className='elevation-3' src={images?.bankTransferLogo} alt='bankTranfer' />
                                            <p className='text-muted well well-sm shadow-none' style={{ marginTop: 10 }}>
                                            </p>
                                        </div>
                                        {/* /.col */}
                                        <div className='col-6'>
                                            <p className='lead'></p>
                                            <div className='table-responsive'>
                                                <table className='table table-sm'>
                                                    <tbody><tr>
                                                        <th style={{ width: '50%' }}>{labels?.subTotal?.[languageObj?.id]}:</th>
                                                        <td className='text-right'>{
                                                            separatorsNumbersSet({
                                                                number: apartmentReceipt?.total,
                                                                withDecimals: true,
                                                                consoleLogErrorShow: true,
                                                                subMethod: 'lbl - subTotal',
                                                            })?.result
                                                        }</td>
                                                    </tr>
                                                        <tr>
                                                            <th>{labels?.tax?.[languageObj?.id]} ({neutralValueStr}%):</th>
                                                            <td className='text-right'>{neutralValueStr}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Total:</th>
                                                            <td className='text-right'>{
                                                                separatorsNumbersSet({
                                                                    number: apartmentReceipt?.total,
                                                                    withDecimals: true,
                                                                    consoleLogErrorShow: true,
                                                                    subMethod: 'lbl - subTotal',
                                                                })?.result
                                                            }</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        {/* /.col */}
                                    </div>
                                    {/* /.row */}

                                    <div className='row'>
                                        <div className='col-12'>
                                            <hr style={{ height: '0.5' }} />
                                        </div>
                                    </div>

                                    <div className='row text-center' style={{ fontSize: 12 }}>
                                        <div className='col-sm-3 text-muted'>
                                            {`${app?.company?.name} `}
                                        </div>
                                        <div className='col-sm-3 text-muted'>
                                            {`${app?.company?.slogan}`}
                                        </div>
                                        <div className='col-sm-3 text-muted'>
                                            {`${app?.company?.url}`}
                                        </div>
                                        <div className='col-sm-3 text-muted'>
                                            {`${app?.name} / ${app?.version} / ${app?.year}`}
                                        </div>
                                    </div>

                                </section>

                            </div>
                        </div>
                        :
                        <></>
                    }
                </div>
                :
                <div className='text-center'
                    style={{ paddingTop: '50px', }}>
                    <LoadingSection alt='loadingSection'
                        className={globalSettings?.react?.html?.overlay?.textMued}
                        //className='overlay text-muted'
                        showText={true}
                        text={messages?.processing?.[languageObj?.id]}
                        height={25}
                        hidden={!showObj}
                        languageId={languageObj?.id}
                        width={25}
                        subMethod={currentMethod} />
                </div>
            }
        </div>
    )
}